import React from 'react';
import { ChevronUp } from 'lucide-react';
import { scrollToTop } from '../../utils';
import './ScrollToTop.css';

const ScrollToTop = ({ show }) => {
  if (!show) return null;
  
  return (
    <button
      onClick={scrollToTop}
      className="scroll-to-top-btn"
    >
      <ChevronUp size={24} />
    </button>
  );
};

export default ScrollToTop;
